import React from "react";
import styled from "styled-components";
import { faPen } from "@fortawesome/free-solid-svg-icons/faPen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FaPen = props => <FontAwesomeIcon icon={faPen} {...props} />;

export const PenIcon = styled(FaPen)`
  margin-right: 10px;
`;
